import {AbsctractValidator} from "./AbstractValidator";

export class MinimunLengthValidator extends AbsctractValidator {
    constructor(input, length) {
        super(input);
        this.length = length;
    }
    isValid() {
        return this.input && this.length && this.input.length >= this.length;
    }
    message() {
        return !this.isValid() ? "Campo de tamanho minímo: " + this.length : "OK";
    }
}

export class MaximumLengthValidator extends AbsctractValidator {
    constructor(input, length) {
        super(input);
        this.length = length;
    }
    isValid() {
        return this.input && this.length && this.input.length <= this.length;
    }
    message() {
        return !this.isValid() ? "Campo de tamanho máximo: " + this.length : "OK";
    }
}

export class ExactLengthValidator extends AbsctractValidator {
    constructor(input, length) {
        super(input);
        this.length = length;
    }
    isValid() {
        return this.input && this.length && this.input.length === this.length;
    }
    message() {
        return !this.isValid() ? "Campo de tamanho igual: " + this.length : "OK";
    }
}




// WEBPACK FOOTER //
// ./src/validator/LengthValidators.js